import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "../components/LoadingSpinner";
import "../styles/Auth.css";
import { FaTimes } from "react-icons/fa";

const Login = ({
  isPopup = false,
  onClose,
  onSwitchToSignup,
  onSwitchToChangePassword,
  onSuccess
}) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      return setError("Please fill in all fields");
    }

    setLoading(true);
    setError("");

    const result = await login(formData.email, formData.password);

    if (result.success) {
      if (isPopup) {
        onSuccess?.(); // Call onSuccess to close modal and handle success
      } else {
        navigate("/");
      }
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleSignup = () => {
    if (isPopup && onSwitchToSignup) {
      onSwitchToSignup(); // Switch to signup form in modal
    } else {
      navigate("/signup"); // Navigate to signup page
    }
  };

  return (
    <div className={`auth-container ${isPopup ? "popup-mode" : ""}`}>
      <div className="auth-form">
        {isPopup && (
          <button className="auth-close-btn" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        )}

        <h2>Sign In</h2>
        {error && <div className="error-message">{error}</div>}

        {loading ? (
          <LoadingSpinner fullscreen />
        ) : (
          <>
            <form className="formalll" onSubmit={handleSubmit}>
              <div className="form-grouplog">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                  autoComplete="email"
                />
              </div>

              <div className="form-grouplog">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                  autoComplete="current-password"
                />
              </div>

              <button type="submit" className="auth-button" disabled={loading}>
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>

            <div className="auth-links">
              {/* Forgot Password */}
              <button
                type="button"
                onClick={() => {
                  handleForgotPassword();
                  onClose();
                }}
                className="auth-link-btn"
              >
                Forgot Password?
              </button>


              {/* Sign up link - only show in full page mode */}
              {!isPopup && (
                <div className="auth-switch">
                  Don't have an account?{" "}
                  <Link to="/signup" className="auth-switch-link">
                    Sign up
                  </Link>
                </div>
              )}

              {/* Switch to Signup in modal mode */}
              {isPopup && (
                <div className="auth-switch">
                  Don't have an account?{" "}
                  <button
                    type="button"
                    onClick={handleSignup}
                    className="auth-switch-btn"
                  >
                    Create account
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;